// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"44a2be30","162":"0b9d0941","226":"4946ead4","401":"d3dcbe1f","442":"84b4fa14"}[chunkId] + ".chunk.js";
};